import { ExtraOrder } from "@/core/reatom/state/orders/types";
import { Block } from "../Block/Block";
import s from "./style.module.scss";

interface AdditionalOrderOptionsProps {
  extra: ExtraOrder[];
}

export const AdditionalOrderOptions = (props: AdditionalOrderOptionsProps) => {
  const { extra } = props;
  return (
    <Block className={s.block}>
      <p className={s.title}>Дополнительные опции</p>
      <div className={s.extraWrapper}>
        {extra.map((item, index) => (
          <div className={s.extraItem} key={index}>
            <p className={s.extraName}>{item.title}</p>
            <p className={s.extraCount}>{item.count} шт</p>
          </div>
        ))}
      </div>
    </Block>
  );
};
